<app-temperature *ngIf="widget === 'temperature'"
                 [resizeEvent]="resizeEvent"
                 [Temperature]="Thing.propertySets.get('TEMPERATUR')">
</app-temperature>

<app-image *ngIf="widget === 'image'"
           [resizeEvent]="resizeEvent"
           [heading]="'Darstellung OLS' | translate"
           [src]="Thing.model3D"
           [equipmentNumber]="Thing.equipmentNumber"
           [alt]="'Darstellung OLS' | translate"
           [ain]="Thing.ainUrl"
           [width]="'auto'">
</app-image>

<app-error-messages *ngIf="widget === 'error-messages'"
                    [resizeEvent]="resizeEvent"
                    [Status]="Thing.propertySets.get('SRC_STATUS')">
</app-error-messages>

<app-movements *ngIf="widget === 'movements'"
               [resizeEvent]="resizeEvent"
               [Movements]="Thing.propertySets.get('MOVEMENTS')">
</app-movements>

<app-orders *ngIf="widget === 'orders'"
            [resizeEvent]="resizeEvent"
            [Orders]="Thing.propertySets.get('ORDERS')">
</app-orders>

<app-time *ngIf="widget === 'time'"
          [resizeEvent]="resizeEvent"
          [Distance]="Thing.propertySets.get('DISTANCE')"
          [TimeGeneral]="Thing.propertySets.get('TIME_GENERAL')">
</app-time>

<app-position *ngIf="widget === 'position'"
              [resizeEvent]="resizeEvent"
              [Position]="Thing.propertySets.get('POSITION')">
</app-position>

<app-fine-positioning *ngIf="widget === 'fine-position'"
                      [resizeEvent]="resizeEvent"
                      [FinePositioning]="Thing.propertySets.get('TIME_FINE_POSITIONING')">
</app-fine-positioning>

<app-finger-movements *ngIf="widget === 'finger-movements'"
                      [resizeEvent]="resizeEvent"
                      [Finger11]="Thing.propertySets.get('FINGER_1_1')"
                      [Finger12]="Thing.propertySets.get('FINGER_1_2')"
                      [Finger21]="Thing.propertySets.get('FINGER_2_1')"
                      [Finger22]="Thing.propertySets.get('FINGER_2_2')"
                      [Finger31]="Thing.propertySets.get('FINGER_3_1')"
                      [Finger32]="Thing.propertySets.get('FINGER_3_2')">
</app-finger-movements>

<app-finger-time *ngIf="widget === 'finger-time'"
                 [resizeEvent]="resizeEvent"
                 [Finger11]="Thing.propertySets.get('FINGER_1_1')"
                 [Finger12]="Thing.propertySets.get('FINGER_1_2')"
                 [Finger21]="Thing.propertySets.get('FINGER_2_1')"
                 [Finger22]="Thing.propertySets.get('FINGER_2_2')"
                 [Finger31]="Thing.propertySets.get('FINGER_3_1')"
                 [Finger32]="Thing.propertySets.get('FINGER_3_2')">
</app-finger-time>

<app-cm-sensors *ngIf="widget === 'cm-mdw'"
                [resizeEvent]="resizeEvent"
                [Type]="''"
                [Environment]="Thing.propertySets.get('DRR_ENV')"
                [Rotation]="Thing.propertySets.get('DRR_ROT')"
                [AngularVelocity]="Thing.propertySets.get('DRR_ANGVEL')"
                [Acceleration]="Thing.propertySets.get('DRR_ACL')">
</app-cm-sensors>

<app-cm-sensors-two *ngIf="widget === 'cm-mdw-two'"
                    [resizeEvent]="resizeEvent"
                    [Type]="''"
                    [Environment]="Thing.propertySets.get('DRR_ENV')"
                    [Sound]="Thing.propertySets.get('DRR_SOUND')"
                    [AngularVelocity]="Thing.propertySets.get('DRR_ANGVEL')"
                    [Acceleration]="Thing.propertySets.get('DRR_ACL')">
</app-cm-sensors-two>
